import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import React, { Component } from 'react';
import { AgGridReact } from 'ag-grid-react';
import PartGroupTableColumnDefinitions from '../ag-grid-definations/partGroup-column-defination';
import PropTypes from 'prop-types';

const rowSelection = 'single';

class PartGroupSearchPanel extends Component {

    state = {
        defaultColumnsAgGrid: [],
    };

    componentWillMount = () => {

        this.loadDefault();

    };

    componentDidUpdate = prevProps => {

        if ( prevProps.isSearch !== this.props.isSearch ) {

            this.loadDefault();

        }

    };

    loadDefault = () => {

        if ( !this.props.isSearch ) {

            const obj = [...PartGroupTableColumnDefinitions];
            obj.forEach( column => {

                if ( column.field === 'productSeriesName' ) {

                    obj.pop();

                    this.setState( {
                        defaultColumnsAgGrid: obj,
                    } );

                }

            } );

        } else {

            const obj = [...PartGroupTableColumnDefinitions];
            this.setState( {
                defaultColumnsAgGrid: obj,
            } );

        }

    }

 onGridReady = params => {

     this.gridApi = params.api;
     params.api.sizeColumnsToFit();

 }

 rowClick = ( props, params ) => {

     const selectedRows = params.api.getSelectedRows();
     let selectedRowsString = '';
     selectedRows.forEach( ( selectedRow, index ) => {

         if ( index !== 0 ) {

             selectedRowsString += ', ';

         }
         selectedRowsString = selectedRow;

     } );

     props.rowClick( selectedRowsString );

 }


 render () {

     return (
         <section className="search-result-table-panel">
             {!this.props.isSearch && (
                 <div className="series-breadcrumb">
                     <span onClick={this.props.gotoPrev}>
                         <span>&lt;</span>
                         {' '}
               &nbsp;
                         {this.props.selectedProductSeries.productSeriesName}
                     </span>
                     <span />
                 </div>
             )}
             {this.props.partGropuList.length > 0 && (
                 <main>
                     <section>
                         <div className="ag-theme-balham ag-theme-popup">
                             <AgGridReact
                                 columnDefs={this.state.defaultColumnsAgGrid}
                                 rowData={this.props.partGropuList}
                                 onGridReady={this.onGridReady}
                                 rowSelection={rowSelection}
                                 onSelectionChanged={this.rowClick.bind( this, this.props )}
                                 popupParent={document.body}
                             />
                         </div>
                     </section>
                 </main>
             )}
             {this.props.partGropuList.length === 0 && <div className="no-search-result">No Result Found</div>}
         </section>
     );

 }

}
PartGroupSearchPanel.displayName = 'PartGroupSearchPanel';
PartGroupSearchPanel.propTypes = {
    isSearch: PropTypes.bool.isRequired,
    partGropuList: PropTypes.array.isRequired,
    selectedProductSeries: PropTypes.object.isRequired,
    gotoPrev: PropTypes.func.isRequired,
};
export default PartGroupSearchPanel;
